module.exports = __webpack_public_path__ + "assets/img/map_CN_i.ad28438d.svg";